/* eslint-disable eqeqeq */
import Instance from "../../../Axios";

const GetIntervencoesMobile =
  (situacaoPreSelectedId, ano, estado, subEstado, perfil) =>
  async (dispatch) => {
    const sitRespondida = situacaoPreSelectedId[0].estado === true ? 1 : 0;
    const sitNaoRespondida = situacaoPreSelectedId[1].estado === true ? 1 : 0;
    const sitAguardaVisita = situacaoPreSelectedId[2].estado === true ? 1 : 0;
    const estadoId = estado.id;
    const subEstadoId = subEstado.id;
    const perfilId = perfil == 3 ? perfil : null;
    await Instance()
      .get(`/intervencoes/intervencoes/mobile`, {
        params: {
          sitRespondida,
          sitNaoRespondida,
          sitAguardaVisita,
          ano,
          estadoId,
          subEstadoId,
          perfilId,
        },
      })
      .then(({ data }) => {
        dispatch({ type: "GET_INTERVENCOES_MOBILE", payload: data.yData });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetIntervencoesMobile;
